import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, useNavigate } from 'react-router-dom';
import DefaultLayout from '../layouts/DefaultLayout';
import AccessDenied from '../pages/Login-page/accessdenied';
import Home from '../pages/home';
import { accountRoutes } from './Accountrouter';
import { appRoutes } from './Approuter';
import { adminRoutes } from './Adminrouter';
import PropTypes from 'prop-types';
import useCheckIdle from '../hooks/checkIdle';
import { logoutUser } from '../store/auth';
import { getNewToken } from '../store/auth/actions';


function Element({ element, layout, secure/*, adminPage */}) {
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const Component = element;
	const Layout = layout;
	const navigate = useNavigate();
	useEffect(() => {
		if (!isAuthenticated && window.location.pathname !== '/login' && window.location.pathname !== '/logout' ) {
			navigate(`/login?returnUrl=${window.location.pathname}`);
		}
	}, [isAuthenticated]);
	// if you want default admin
	//useEffect(() => {
	//	if (adminPage && !isAdmin) {
	//		navigate('/');
	//	}
	//}, []);

	useEffect(() => {
		if (secure && !isAuthenticated) {
			navigate('/login');
		}
	}, [isAuthenticated]);

	//if (adminPage && !isAdmin) return null; 	// if you want default admin
	//else
		if (secure && !isAuthenticated) return null;
	else {
		return (
			<Layout>
				<Component />
			</Layout>
		);
	}
}

Element.propTypes = {
	element: PropTypes.any,
	layout: PropTypes.any,
	secure: PropTypes.bool,
	adminPage: PropTypes.bool
};

Element.defaultProps = {
	secure: true,
	adminPage: false
}


export const createRoutes = (routesData) =>
	routesData.map((route) => {
		if (route.routes?.length) {
			const indexRoute = route.routes.find((r) => r.index);
			return (
				<Route
					key={route.path}
					path={route.path}
					element={<Element {...route} />}
					index={route.index}
				>
					{!!indexRoute && (
						<Route index element={<Element {...route} />} />
					)}
					{createRoutes(route.routes)}
				</Route>
			);
		}
		return (
			<Route
				key={route.path}
				path={route.path}
				element={<Element {...route} />}
				index={route.index}
			/>
		);
	});

export default function AppRouter() {
	const [isIdle, reset, getTotalActiveTime, start] = useCheckIdle(onUserActive);
	const dispatch = useDispatch();

	const { isAuthenticated, refreshToken } = useSelector((state) => state.auth);
	const idletimeOut = 1000 * 60 * process.env.REACT_APP_IDLE_TIMEOUT;
	const timeToSendAPI = 1000 * 60 * process.env.REACT_APP_TOKEN_CALL_TIMEOUT;
	function onUserActive() {
		if (isAuthenticated) {
			const totalActiveTime = getTotalActiveTime();
			if (totalActiveTime >= timeToSendAPI && totalActiveTime <= idletimeOut) {
				dispatch(getNewToken({ refreshtoken: refreshToken }))
				reset();
				start();
				return;
			}
		}
	}
	useEffect(() => {
		if (isAuthenticated) {
			if (isIdle) {
				reset();
				dispatch(logoutUser());
				window.location.href = '/login';
				return;
			}
		}
	}, [isIdle]);
	return (
		<Routes>
			{createRoutes(accountRoutes)}
			{createRoutes(appRoutes)}
			{createRoutes(adminRoutes)}
			<Route
				path='/'
				element={<DefaultLayout><Home /></DefaultLayout>}
			/>
			<Route
				path='access-denied'
				element={<AccessDenied />}
			/>
		</Routes>);
}